import React from "react"
import autobind from "class-autobind"
import { IDateRange, ITimecard,IObjectTimecardDocument } from "../../../models"
import TimecardDailyDrawerContent from "./TimecardDailyDrawerContent"
interface IProps {
    // if byEmployee is true, employee timecard drawer, else equipment
    byEmployee?: boolean
    dayNum: number
    imageS3Url: string
    timecard: IObjectTimecardDocument
    enableBreadcrumb?: boolean
    closeDailyDrawer(): void

    // daily note drawer
    userId?: string
    objectTimecardId?: string
    timecardDates?: IDateRange
}
interface IState {
    openDrawer: boolean
}

export default class TimecardDailyDrawer extends React.Component<IProps, IState>  {
    constructor(props) {
        super(props)
        this.state = {
            openDrawer: false
        }
        autobind(this)
    }

    componentWillReceiveProps(nextProps: IProps) {
        nextProps.dayNum !== null &&
            setTimeout(() =>
                this.setState({ openDrawer: true }), 10
            )
    }

    closeDailyDrawer() {
        this.setState({ openDrawer: false }, () =>
            setTimeout(() =>
                this.props.closeDailyDrawer(), 100
            )
        )
    }

    render() {
        return this.props.timecard && this.props.dayNum !== null && (
            <TimecardDailyDrawerContent
                byEmployee={this.props.byEmployee}
                open={this.state.openDrawer}
                dayNum={this.props.dayNum}
                timecard={this.props.timecard}
                imageS3Url={this.props.imageS3Url}
                objectTimecardId={this.props.objectTimecardId}
                userId={this.props.userId}
                timecardDates={this.props.timecardDates}
                enableBreadcrumb={this.props.enableBreadcrumb}
                closeDailyDrawer={this.closeDailyDrawer}
            />
        )
    }
}
